module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-up.svg.3faa8a34.svg";